export const UPLOAD_JOB_ID_KEY = 'uploadJobId' as const
